<template>
  <div id="app">

    <b-container>
      <b-row class="justify-content-md-center">
        <b-col lg="8">
          <Form />
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import Form from './components/form.vue'

export default {
  name: 'App',
  components: {
    Form
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
